<template>
  <div class="trending-social">
    <div class="section-title">
      <h3 class="title">关于我们</h3>
    </div>
    <ul>
      <li>
        <a href="javascript:;">
          <i class="fab fa-weixin"></i>
          <span>公众号</span>
          <p>关注</p>
        </a>
      </li>
      <li>
        <a class="item-2" target="_blank" :href="`${site?.domain}`">
          <i class="fas fa-globe"></i>
          <span>网站</span>
          <p>点击访问</p>
        </a>
      </li>
      
      <li>
        <a class="item-3" :href="`mailto:${site?.email}`">
          <i class="fas fa-envelope"></i>
          <span>联系邮箱</span>
          <p>联系我们</p>
        </a>
      </li>
    </ul>
    <!--
    <ul>
      <li>
        <a class="item-4" href="#">
          <i class="fab fa-instagram"></i>
          <span>34,456</span>
          <p>Followers</p>
        </a>
      </li>
      <li>
        <a class="item-5" href="#">
          <i class="fab fa-vimeo-v"></i>
          <span>34,456</span>
          <p>Followers</p>
        </a>
      </li>
      <li>
        <a class="item-6" href="#">
          <i class="fab fa-maxcdn"></i>
          <span>34,456</span>
          <p>Fans</p>
        </a>
      </li>
    </ul>
    -->
  </div>
</template>

<script>
export default {
  inject: ['siteData'],
  computed: {
    site() {
      return this.siteData.site;
    }
  },
};
</script>

<style scoped>
.trending-social {
  /* 桌面端默认样式，上边距为 0 */
  margin-top: 0;
}

/* 小屏幕，例如手机 */
@media (max-width: 768px) {
  .trending-social {
    /* 小屏幕增加上边距，可根据实际需求调整 */
    margin-top: 20px;
  }
}
</style>